import styled, { css } from 'styled-components'
import variables, { colors } from 'Styled/variables'

export const SidebarLinkItem = styled.li`
  color: ${colors.mainText};
  height: 40px;
  transition: all 0.3s;
  cursor: pointer;
  display: flex;
  background: transparent;
  border: none;
  align-items: center;

  ${({ collapse }: { collapse: boolean }) =>
    collapse
      ? css`
          flex-direction: column;
          justify-content: center;
        `
      : css`
          width: 240px;
          padding: 12px 16px;
        `};
`

export const SidebarLinkText = styled.div`
  color: ${colors.mainText};
  margin: 0;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  position: relative;
  display: flex;
  left: 10px;
  width: 160px;
`

export const SidebarIconBlock = styled.div`
  margin-right: 6px;
`

export const NewLabel = styled.span`
  margin-left: 9px;
  color: ${colors.badgeGreen};
  font-size: 14px;
  line-height: 21px;
`
